import { GridColDef } from "@mui/x-data-grid";

// helper function to make additional changes to the column definitions

export const makeColumn = (def: GridColDef): GridColDef => {
  def = {
    ...def,
    filterable: false,
    headerClassName: "grid-header",
  };
  if (["id", "ars_lnd"].indexOf(def.field) > -1) return def;

  return { ...def, editable: true };
};
